import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Grid } from "@gcs/design-system/react";
import DoubleContentStyled, { DoubleConentColumn } from "./DoubleContent.Style";

const DoubleContent = (props) => {
  const GRID_MAX_COLLUMNS = 12;
  const GRID_MINIMUM_COLLUMNS = 1;

  const { leftContent, rightContent, collumnSize, children } = props;
  const rightColumn = useMemo(() => GRID_MAX_COLLUMNS - collumnSize, [
    collumnSize,
  ]);

  return (
    <DoubleContentStyled {...props} as={Grid}>
      <DoubleConentColumn
        as={Grid.Item}
        xs={GRID_MINIMUM_COLLUMNS}
        sm={GRID_MINIMUM_COLLUMNS}
        md={GRID_MINIMUM_COLLUMNS}
        lg={collumnSize / GRID_MAX_COLLUMNS}
        xl={collumnSize / GRID_MAX_COLLUMNS}
        className="DoubleContent__ResizableColumn"
      >
        {leftContent}
      </DoubleConentColumn>
      <DoubleConentColumn
        as={Grid.Item}
        xs={GRID_MINIMUM_COLLUMNS}
        sm={GRID_MINIMUM_COLLUMNS}
        md={GRID_MINIMUM_COLLUMNS}
        lg={rightColumn / GRID_MAX_COLLUMNS}
        xl={rightColumn / GRID_MAX_COLLUMNS}
        className="DoubleContent__ContentColumn"
      >
        {rightContent || children}
      </DoubleConentColumn>
    </DoubleContentStyled>
  );
};

DoubleContent.defaultProps = {
  leftContent: null,
  rightContent: null,
  collumnSize: 6,
  reverse: false,
};

DoubleContent.propTypes = {
  leftContent: PropTypes.element,
  rightContent: PropTypes.element,
  collumnSize: PropTypes.number,
  reverse: PropTypes.bool,
};

export default DoubleContent;
